import styled, { css } from 'styled-components';

export const CardContainer = styled.div`
  background: #ffffff;
  border-left: 4px solid ${({ $borderColor }) => $borderColor || '#007bff'};
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: inline-flex;
  align-items: center;
  transition: box-shadow 0.2s ease;

  ${({ $isGrande }) =>
    $isGrande
      ? css`
          padding: 20px 24px;
          min-width: 200px;
        `
      : css`
          padding: 6px 14px;
          min-width: auto;
          gap: 8px;
        `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const Valor = styled.span`
  color: #212529;
  margin: 0;

  ${({ $isGrande }) =>
    $isGrande
      ? css`
          font-size: 2rem;
          font-weight: 700;
          line-height: 1.2;
        `
      : css`
          font-size: 0.95rem;
          font-weight: 700;
          line-height: 1.3;
        `}
`;

export const Titulo = styled.span`
  color: #6c757d;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;

  ${({ $isGrande }) =>
    $isGrande
      ? css`
          font-size: 0.85rem;
          margin-top: 4px;
        `
      : css`
          font-size: 0.7rem;
          line-height: 1.2;
        `}
`;

export const BotoesContainer = styled.div`
  display: flex;
  gap: 4px;
  margin-left: auto;

  ${({ $isGrande }) =>
    $isGrande &&
    css`
      gap: 8px;
      margin-left: 16px;
    `}
`;

export const Botao = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  color: #6c757d;

  ${({ $isGrande }) =>
    $isGrande
      ? css`
          width: 36px;
          height: 36px;
          padding: 6px;
        `
      : css`
          width: 24px;
          height: 24px;
          padding: 4px;
        `}
`;
